import { Injectable } from '@angular/core';
import { mergeMap } from 'rxjs';
import { FirebaseService } from './firebase.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { PaymentStatus } from './payments.service';
import { AuthorizeNetTransaction } from './desktop-payments.service';

export type ApiPayment = {
  id: string;
  api_invoice_id: string;
  completed: boolean;
  status: PaymentStatus;
  status_description: string;
  created_at: string;
  updated_at: string;
};

export type ApiPaymentDetails = {
  api_payment: ApiPayment;
  payment_method: string;
  transactions: AuthorizeNetTransaction[];
};

export type ApiPaymentResponse = {
  api_payment: ApiPayment;
};

export type ApiPaymentDetailsResponse = {
  api_payment_details: ApiPaymentDetails;
};

@Injectable({
  providedIn: 'root',
})
export class ApiPaymentsService {
  getApiPaymentByInvoiceIdUrl =
    environment.serverUrl + '/api-payments/get-for-invoice';
  constructor(
    private firebaseService: FirebaseService,
    private http: HttpClient
  ) {}

  getApiPaymentDetails(invoiceId: string) {
    return this.firebaseService.idToken().pipe(
      mergeMap((token) => {
        return this.http.get<ApiPaymentDetailsResponse>(
          this.getApiPaymentByInvoiceIdUrl + '/' + invoiceId,
          {
            headers: {
              Authorization: 'Bearer ' + token,
            },
          }
        );
      })
    );
  }
}
